import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWeigerWoning1 = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="m8 14 12-8 12 8v20H8z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="m29.646 15.697-15.81 17.11-3.672-3.394 15.81-17.11z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="m14.026 12.303 15.81 17.11-3.672 3.394-15.81-17.11z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m16.725 12.203 3.721 4.007-.732.68-3.04-3.273-2.923 2.729-.682-.732zM19.706 28.443l.728-.686 3.514 3.734 3.137-2.832.67.742-3.863 3.488z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWeigerWoning1);

export default ForwardRef;
